import { ErrorPage } from "@/components/ui/ErrorPage";

export default function LinkScaduto() {
  return (
    <ErrorPage
      emoji="⏰"
      titolo="Il link è scaduto"
      messaggio={
        <>
          Il link di accesso era valido per <strong>15 minuti</strong>.<br />
          Richiedine uno nuovo per continuare.
        </>
      }
      cta={{ label: "Richiedi nuovo link", to: "/accedi" }}
    />
  );
}
